export class WhatsNew {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {

    return {
      id: this.fields?.attributes?.id,
      title: this.fields?.attributes?.title,
      content: this.fields?.attributes?.relationships
    };
  }
}
